module.exports = __webpack_public_path__ + "static/media/logo_egyption_steel.5dd4f6f6.png";